<template>
  <i-form
    v-scroll-to-invalid
    class="form"
    name="tapes-form"
    @submit="handleSubmit"
  >
    <div class="type">
      <strapi-label :label="labels[LabelsLabels.type]" />
      <div class="form-field-group">
        <!--type field-->
        <zaproo-select
          v-if="fields[LabelsFields.type]"
          v-model="form.type"
          :removable="false"
          searchable
          highlight
          :no-result-label="$t('No results found')"
          no-result-class="text-neutral-900/50 text-center !py-2 !px-4"
          name="type"
          :rules="fieldRules[LabelsFields.type]"
          :placeholder="$t('Select option')"
          dropdown-classes="py-2 mt-2"
          class="form-field checkmark"
        >
          <template #label>
            <special-order-form-input-label
              :field="fields[LabelsFields.type]"
            />
          </template>

          <zaproo-select-option
            v-for="option in fields[LabelsFields.type].options"
            :key="option.value"
            :value="option.value"
            :label="option.title"
          />
        </zaproo-select>
      </div>
      <div class="form-field-checkbox-group">
        <zaproo-checkbox v-model="form.detachable" name="detachable">
          <special-order-form-input-label
            class="!mt-0"
            :field="fields[LabelsFields.detachable]"
          />
        </zaproo-checkbox>
      </div>
    </div>
    <div class="dimensions mt-6">
      <strapi-label :label="labels[LabelsLabels.dimensions]" />
      <div class="form-field-group">
        <zaproo-select
          v-if="fields[LabelsFields.shape]"
          v-model="form.shape"
          :removable="false"
          name="shape"
          :rules="fieldRules[LabelsFields.shape]"
          :placeholder="$t('Select option')"
          dropdown-classes="py-2 mt-2"
          class="form-field checkmark"
        >
          <template #label>
            <special-order-form-input-label
              :field="fields[LabelsFields.shape]"
            />
          </template>

          <zaproo-select-option
            v-for="option in fields[LabelsFields.shape].options"
            :key="option.value"
            :value="option.value"
          >
            {{ option.title }}
          </zaproo-select-option>
        </zaproo-select>
      </div>
      <div class="form-field-group">
        <zaproo-input
          v-if="isRoundSelect"
          v-model="form.diameter"
          type="number"
          name="diameter"
          :rules="fieldRules[LabelsFields.diameter]"
          :placeholder="fields[LabelsFields.diameter].placeholder"
          :description="fields[LabelsFields.diameter].description"
          class="form-field"
        >
          <template #label>
            <special-order-form-input-label
              :field="fields[LabelsFields.diameter]"
            />
          </template>
        </zaproo-input>

        <template v-else>
          <zaproo-input
            v-model="form.width"
            type="number"
            name="width"
            :rules="fieldRules[LabelsFields.width]"
            :placeholder="fields[LabelsFields.width].placeholder"
            :description="fields[LabelsFields.width].description"
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[LabelsFields.width]"
              />
            </template>
          </zaproo-input>

          <zaproo-input
            v-model="form.length"
            type="number"
            name="length"
            :rules="fieldRules[LabelsFields.length]"
            :placeholder="fields[LabelsFields.length].placeholder"
            :description="fields[LabelsFields.length].description"
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[LabelsFields.length]"
              />
            </template>
          </zaproo-input>
        </template>
      </div>
    </div>
    <div class="colors mt-6">
      <strapi-label :label="labels[LabelsLabels.color]" />
      <div class="form-field-group">
        <zaproo-select
          v-if="fields[LabelsFields.mainColor]"
          v-model="form.mainColor"
          :removable="false"
          name="mainColor"
          :rules="fieldRules[LabelsFields.mainColor]"
          :placeholder="$t('Select option')"
          dropdown-classes="py-2 mt-2"
          class="form-field checkmark"
        >
          <template #label>
            <special-order-form-input-label
              :field="fields[LabelsFields.mainColor]"
            />
          </template>

          <zaproo-select-option
            v-for="option in fields[LabelsFields.mainColor].options"
            :key="option.value"
            :value="option.value"
          >
            {{ option.title }}
          </zaproo-select-option>
        </zaproo-select>
        <zaproo-input
          v-if="isOtherSelect"
          v-model="form.otherMainColor"
          name="otherMainColor"
          :rules="fieldRules[LabelsFields.otherMainColor]"
          :placeholder="fields[LabelsFields.otherMainColor].placeholder"
          :description="fields[LabelsFields.otherMainColor].description"
          class="form-field"
        >
          <template #label>
            <special-order-form-input-label
              :field="fields[LabelsFields.otherMainColor]"
            />
          </template>
        </zaproo-input>
      </div>
    </div>
    <div class="print mt-6">
      <strapi-label :label="labels[LabelsLabels.print]" />
      <div class="form-field-group">
        <zaproo-select
          v-if="fields[LabelsFields.printColors]"
          v-model="form.printColors"
          :removable="false"
          name="shape"
          :rules="fieldRules[LabelsFields.printColors]"
          :placeholder="$t('Select option')"
          dropdown-classes="py-2 mt-2"
          class="form-field checkmark"
        >
          <template #label>
            <special-order-form-input-label
              :field="fields[LabelsFields.printColors]"
            />
          </template>

          <zaproo-select-option
            v-for="option in fields[LabelsFields.printColors].options"
            :key="option.value"
            :value="option.value"
          >
            {{ option.title }}
          </zaproo-select-option>
        </zaproo-select>
      </div>
      <div class="form-field-group">
        <zaproo-file-input
          v-if="isPrintDesignFile"
          v-model="form.designFile"
          class="form-file-field mt-3"
          name="designFiles"
          multiple
          :rules="fieldRules[LabelsFields.designFile]"
          :total-size-of-files="INPUT_FILE_TOTAL_SIZE"
          :placeholder="fields[LabelsFields.designFile].placeholder"
        >
          <template #label>
            <special-order-form-input-label
              :field="fields[LabelsFields.designFile]"
            />
          </template>
          <template #removeFileText>
            <icons-icon-trash />
            {{ $t("Remove") }}
          </template>
          <template #fileError="{ errors, clear }">
            <div class="mb-2 grid grid-cols-1 gap-2">
              <file-input-error-notification :clear="clear" :errors="errors" />
            </div>
          </template>
        </zaproo-file-input>
      </div>
    </div>
    <special-order-form-general-contacts-part
      v-model="form"
      class="general-contacts-form"
      :loading="loading"
    >
      <zaproo-input
        v-model="form.amountPcs"
        type="number"
        name="amountPcs"
        :rules="!!fields[LabelsFields.amountPcs]?.required ? 'required' : ''"
        :placeholder="fields[MultilayerBagsFields.amountPcs].placeholder"
        :description="fields[MultilayerBagsFields.amountPcs].description"
        class="form-field"
      >
        <template #label>
          <special-order-form-input-label
            :field="fields[MultilayerBagsFields.amountPcs]"
          />
        </template>
      </zaproo-input>
    </special-order-form-general-contacts-part>
  </i-form>
</template>
<script setup lang="ts">
import { Form as IForm, FormActions } from "vee-validate";
import SpecialOrderFormInputLabel from "../../SpecialOrderForm/SpecialOrderFormInputLabel.vue";
import type {
  StrapiField,
  StrapiLabel as StrapiLabelType,
  StrapiSpecialOrders,
} from "~/types/strapi";

import { getFieldDefaultModel } from "~/modules/special-orders/helpers";
import {
  LabelsFields,
  LabelsLabels,
} from "~/modules/special-orders/components/SpecialOrderForm/Labels/types";
import StrapiLabel from "~/components/strapi/components/shared/StrapiLabel.vue";
import { INPUT_FILE_TOTAL_SIZE } from "~/modules/special-orders/variables";
import FileInputErrorNotification from "~/modules/special-orders/components/SpecialOrderForm/FileInputErrorNotification.vue";
import { MultilayerBagsFields } from "~/modules/special-orders/components/SpecialOrderForm/MultilayerBags/types";
import { useFormFieldCleaner } from "~/modules/special-orders/composables/useFormFieldCleaner";

const props = defineProps<{
  specialOrder: StrapiSpecialOrders;
}>();

const { collection: labelCollection } =
  useSpecialOrderUidDictionary<StrapiLabelType>(props.specialOrder.labels);

const { collection: fieldsCollection } =
  useSpecialOrderUidDictionary<StrapiField>(props.specialOrder.fields);

const { sendRequest, loading } = useSpecialOrdersSubmit(props.specialOrder);

const labels = computed(() => labelCollection(LabelsLabels));
const fields = computed(() => fieldsCollection(LabelsFields));
const fieldRules = useSpecialOrderFieldRules<typeof LabelsFields>(fields.value);

const isRoundSelect = computed(() => form.value.shape === "round");
const isOtherSelect = computed(() => form.value.mainColor === "other");
const isPrintDesignFile = computed(() => form.value.printColors !== "0");

const form = ref<ReturnType<typeof resetForm>>(resetForm());

function resetForm() {
  return {
    type: getFieldDefaultModel(fields.value[LabelsFields.type]),
    detachable: !!getFieldDefaultModel(fields.value[LabelsFields.detachable]),
    shape: getFieldDefaultModel(fields.value[LabelsFields.shape]),
    width: getFieldDefaultModel(fields.value[LabelsFields.width]),
    length: getFieldDefaultModel(fields.value[LabelsFields.length]),
    diameter: getFieldDefaultModel(fields.value[LabelsFields.diameter]),
    mainColor: getFieldDefaultModel(fields.value[LabelsFields.mainColor]),
    otherMainColor: getFieldDefaultModel(
      fields.value[LabelsFields.otherMainColor],
    ),
    printColors: getFieldDefaultModel(fields.value[LabelsFields.printColors]),
    amountPcs: getFieldDefaultModel(fields.value[LabelsFields.amountPcs]),
    designFile: [],
    email: "",
    phone: "",
    additionalInfo: "",
  };
}

async function handleSubmit(
  _: Record<string, unknown>,
  { resetForm: reset }: FormActions<Record<string, unknown>>,
) {
  await sendRequest(form.value);
  reset();
  form.value = resetForm();
}

useFormFieldCleaner(
  {
    designFile: {
      default: () => [],
      ref: isPrintDesignFile,
    },
    otherMainColor: {
      default: () =>
        getFieldDefaultModel(fields.value[LabelsFields.otherMainColor]),
      ref: isOtherSelect,
    },
    diameter: {
      default: () => getFieldDefaultModel(fields.value[LabelsFields.diameter]),
      ref: isRoundSelect,
    },
  },
  form,
);
</script>
